import React from 'react';
import Countdown, { zeroPad } from 'react-countdown-now';
import TimeSync from 'utils/TimeSync';

function AuctionCountdown({ startTime, endTime, inProgress }) {
  const renderCountdown = ({ days, hours, minutes, seconds }) => {
    const totalHours = days ? days * 24 + hours : hours;
    return (
      <span className="notranslate">
        {zeroPad(totalHours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds)}
      </span>
    );
  };

  const renderInProgress = ({ days, hours, minutes, seconds, total }) => {
    const totalHours = days ? days * 24 + hours : hours;
    return (
      <span
        className={
          'notranslate' + (total < 60000 ? ' red-timer' : ' yellow-timer')
        }
      >
        {zeroPad(totalHours) + ':' + zeroPad(minutes) + ':' + zeroPad(seconds)}
      </span>
    );
  };

  const targetTime = startTime || endTime;
  const renderer = inProgress ? renderInProgress : renderCountdown;

  return (
    <Countdown
      date={TimeSync.toLocalTime(targetTime)}
      renderer={renderer}
      key={targetTime}
    />
  );
}

export default AuctionCountdown;
